import { useCallback, useState } from "react";
import { canv } from "@/canv/global";

type UseEditableTitleProps = {
    onSubmit: (value: string) => void;
};

export const useEditableTitle = ({ onSubmit }: UseEditableTitleProps) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleTitleClick = useCallback((e: React.MouseEvent<HTMLParagraphElement>) => {
        e.stopPropagation();
        const isEditorOrOwner = canv.isBoardModeEditOrOwner();

        if (e.detail === 2 && isEditorOrOwner) {
            setIsEditing(true);
        }
    }, []);

    const handleSubmit = useCallback(
        (value: string) => {
            onSubmit(value);
            setIsEditing(false);
        },
        [onSubmit],
    );

    const handleCancel = useCallback(() => {
        setIsEditing(false);
    }, []);

    return {
        isEditing,
        setIsEditing,
        handleTitleClick,
        handleSubmit,
        handleCancel,
    };
};
